<template>
  <div>
    <NavigationUserBar></NavigationUserBar>
    <v-main>
      <NavigationAppbar></NavigationAppbar>
        <div style="padding: 0 !important;">
          <v-container fluid>
            <router-view></router-view>
          </v-container>
        </div>
    </v-main>
<!--    <v-footer app>
      <LayoutFooter></LayoutFooter>
    </v-footer>-->
  </div>
</template>

<script>
// import LayoutFooter from '../../views/admin/layout/LayoutFooter'
import NavigationAppbar from '../../views/user/layout/Appbar'
import NavigationUserBar from '@/views/user/layout/NavBar'
export default {
  name: 'Layout',
  components: { NavigationUserBar, NavigationAppbar }
}
</script>

<style scoped>
  .container-fluid{
    width: 100% !important;
    padding: 0;
    margin: 0;
  }
</style>
